<template>
  <div id="history">
    <div id="history-text">
      <h3>the great swamp in new jersey is formed</h3>
      <p>
        15,000 years ago, the Great Wisconsin glacier retreated slowly northward
        leaving vast quantities of rock, soil, and glacial till. As it
        retreated, the melting waters of the glacier flowed into a basic forming
        a lake measuring 30 miles long by 10 miles wide. As the water continued
        to retreat and drain out towards the Hudson River, The Great Swamp was
        formed, flanked by the Wachung Mountains
      </p>
    </div>
    <img src="../assets/newJersey@2x.png" />
    <div id="glaciers">
      <img src="../assets/glaciers.svg" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'History',
  props: ['addScrollTarget'],
  mounted() {
    //this.addScrollTarget('#history #glaciers')
  },
}
</script>
<style>
#history {
  position: relative;
  height: 100vh;
  display: block;
}
#history #history-text {
  position: absolute;
  top: 7%;
  left: 35px;
  width: 800px;
}
#history h3 {
  color: var(--blue-text);
  margin-bottom: 0.5em;
  text-align: left;
}
#history #history-text p {
  font-size: 17px;
  line-height: 29px;
  font-weight: 300;
  text-align: left;
  width: 80%;
  left: 5%;
  position: relative;
}
#history > img:nth-of-type(1) {
  height: 525px;
  position: absolute;
  left: 775px;
  top: 25px;
}
@keyframes melting {
  0% {
    opacity: 1;
  }
  1% {
    opacity: 0.5;
  }
  2% {
    opacity: 0.1;
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 0;
    transform: translateY(100%);
  }
}
#history #glaciers {
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: auto;
  width: auto;
  animation-name: melting;
  animation-duration: 500s;
  animation-fill-mode: backwards;
  animation-iteration-count: infinite;
}

#history #glaciers img {
  height: 650px;
}
</style>
